module.exports = __webpack_public_path__ + "media/images/bg_contents-dd0c5b946a8bca276dc9814f2cb4c93e.png";